import { Checkbox, Text } from '@mantine/core';
import styles from './layersandfilters.module.css';

interface DropdownContentProps {
  items: { label: string; checked: boolean; onChange: (checked: boolean) => void }[];
}

export function DropdownContent({ items }: DropdownContentProps) {
  return (
    <ul className={styles.dropdownContent}>
      {items.map((item, index) => (
        <li key={index} className={styles.dropdownItem}>
          <div className={styles.checkboxAndText}>
            <Checkbox
              size="16"
              checked={item.checked}
              onChange={(event) => item.onChange(event.currentTarget.checked)}
              className={styles.checkbox}
            />
            <Text className={styles.dropdownText}>{item.label}</Text>
          </div>
        </li>
      ))}
    </ul>
  );
}
